import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTiposExamenesMedicos } from "../../../../../../redux/actions/resolucion";
import InformarExamenesForm from "./InformarExamenesForm";

// No tiene initialValues ya que todos los valores son dinamicos traidos del back y son todos bool.

const InformarExamenesFormContainer = ({ callback, open, handleClose, values, fechaIngreso }) => {

  const dispatch = useDispatch();
  const tiposExamenesMedicos = useSelector((state) => state.resolucion.tiposExamenesMedicos.data);
  const [formValues, setFormValues] = useState();

  useEffect(() => {
    if (tiposExamenesMedicos.length === 0) {
      dispatch(getTiposExamenesMedicos());
    }
  }, [dispatch, tiposExamenesMedicos.length])

  useEffect(() => {
    if (tiposExamenesMedicos.length !== 0) {
      setFormValues({
        idSustancia: values?.idSustancia,
        inicioContacto: values?.inicioContacto ?? null,
        finContacto: values?.finContacto ?? null,
        ...tiposExamenesMedicos.reduce((tiposExamenesMedicos, tipoExamenMedicos) => {
          tiposExamenesMedicos[tipoExamenMedicos.id] = {
            value: values?.[tipoExamenMedicos.id]?.value ?? false
          };
          return tiposExamenesMedicos
        }, {}),
      });
    }

  }, [open, tiposExamenesMedicos.length, values])

  const handleSubmit = (values) => {
    if (callback) {
      callback(values)
    }
    handleClose();
  }
  return (
    <InformarExamenesForm
      open={open}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      initialValues={formValues}
      examenesMedicos={tiposExamenesMedicos}
      fechaIngreso={fechaIngreso}
    />
  )

}

export default InformarExamenesFormContainer;